import React, { useState, useEffect } from 'react';
import InnerHeader from './InnerHeader';
import { BASE_URL } from './BaseUrl';
import axios from "axios";
import { Link, useParams } from 'react-router-dom';

const SalaryStructure = () => {
  const params = useParams();
  const empolyeeid = params.empolyeeid || params.employeeid;
  const [rows, setRows] = useState([]);
  const [visibleFormIndex, setVisibleFormIndex] = useState(null);
  const [salaryType, setSalaryType] = useState('Hourly');

const [formData, setFormData] = useState({
  FromDate: '',
  ToDate: '',
  SalaryType: salaryType,
  StdWHrs: 0,
  StdWHRate: 0,
  OTRate: 0,
  BasicDA_Percent: 0,
  DA_Amount: 0,
  HRA_Percent: 0,
  Call_Percent: 0,
  Convey_Percent: 0,
  Other_Percent: 0,
  GrossAmount: 0,
  BasicAmount: 0,
  DA_Component: 0,
  HRA_Amount: 0,
  Call_Amount: 0,
  Convey_Amount: 0,
  Other_Amount: 0,
  OT: false,
  PT: false,
  PF: false,
  TDS: false,
  MLWF: false,
  ESIC: false,
  Leaves: 0,
});

  const handleToggleForm = (index) => {
    setVisibleFormIndex(prevIndex => (prevIndex === index ? null : index));
  };
 useEffect(() => {
  const fetchSalaryStructure = async () => {
    if (!empolyeeid || empolyeeid === ":empolyeeid" || empolyeeid === "undefined") {
      setRows([]);
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}/get_Emp_salary/${empolyeeid}`, { empolyeeid });
      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        const formattedData = data.map((item) => ({
          Id: item.Id || item.SalaryID || null,
          Emp_Id: item.Emp_Id || null,
          SalaryHead: item.SalaryHead || "",
          Amount: item.Amount || 0,
          Type: item.Type || "",
        }));
        setRows(formattedData);
      } else {
        setRows([]);
      }
    } catch (error) {
      console.error("Error fetching salary structure:", error);
      setRows([]);
    }
  };

  if (empolyeeid && empolyeeid !== ":empolyeeid" && empolyeeid !== "undefined") {
    fetchSalaryStructure();
  }
}, [empolyeeid]);


 // ✅ Handle form change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  function formatDateToYYYYMMDD(dateString) {
     const date = new Date(dateString);
     if (isNaN(date)) return ""; // handle invalid date
     const year = date.getFullYear();
     const month = (`0${date.getMonth() + 1}`).slice(-2); // pad with 0
     const day = (`0${date.getDate()}`).slice(-2);
     return `${year}-${month}-${day}`;
 }

  const handleSave = async (e) => {
  e.preventDefault();

  if (!rows || rows.length === 0) {
    alert("No salary data to save.");
    return;
  }

  const records = rows.map((formData) => ({
    SalaryID:formData.SalaryID || null,
    FromDate: formatDateToYYYYMMDD(formData.FromDate),
    ToDate: formatDateToYYYYMMDD(formData.ToDate),
    SalaryType: formData.SalaryType || '',
    StdWHrs: formData.StdWHrs || 0,
    StdWHRate: formData.StdWHRate || 0,
    OTRate: formData.OTRate || 0,
    BasicDA_Percent: formData.BasicDA_Percent || 0,
    DA_Amount: formData.DA_Amount || 0,
    HRA_Percent: formData.HRA_Percent || 0,
    Call_Percent: formData.Call_Percent || 0,
    Convey_Percent: formData.Convey_Percent || 0,
    Other_Percent: formData.Other_Percent || 0,
    GrossAmount: formData.GrossAmount || 0,
    BasicAmount: formData.BasicAmount || 0,
    DA_Component: formData.DA_Component || 0,
    HRA_Amount: formData.HRA_Amount || 0,
    Call_Amount: formData.Call_Amount || 0,
    Convey_Amount: formData.Convey_Amount || 0,
    Other_Amount: formData.Other_Amount || 0,
    OT: formData.OT || 0,
    PT: formData.PT || 0,
    TDS: formData.TDS || 0,
    MLWF: formData.MLWF || 0,
    ESIC: formData.ESIC || 0,
    Leaves: formData.Leaves || 0,
  }));

  const payload = {
    employeeid: empolyeeid,
    createdBy: "admin",
    updatedBy: "admin",
    records: records
  };

  try {
    const response = await axios.post(`${BASE_URL}/save_or_update_salary_records`, payload);

    if (response.data.success) {
      alert("Salary structure saved successfully!");
      // Optionally refresh rows from DB
    } else {
      alert("Failed to save salary structure: " + response.data.message);
    }
  } catch (err) {
    console.error("Error saving salary structure:", err);
    alert("An error occurred while saving salary structure.");
  }
};




   const SalaryForm = () => (
    <div className="mt-3 p-3 bg-white border rounded">
      <h5><strong>Add Salary Info</strong></h5>
      <div className="row mb-2">
        <div className="col-md-3">
          <label>Date : From</label>
          <input type="date" className="form-control" name='FromDate' value={formData.FromDate}/>
        </div>
        <div className="col-md-3">
          <label>To</label>
          <input type="date" className="form-control"  name='ToDate' value={formData.ToDate}/>
        </div>
        <div className="col-md-3">
          <label>Type</label>
          <select className="form-control" name='SalaryType' value={formData.salaryType} onChange={(e) => setSalaryType(e.target.value)}>
            
            <option>Hourly</option>
            <option>Monthly</option>
            <option>Professional</option>
          </select>
        </div>
      </div>

      {salaryType === 'Hourly' || salaryType === 'Professional' ? (
        <div className="row bg-light p-3 rounded">
          <div className="col-md-2"><label>Std. W.H. (Hrs)</label><input type="number" className="form-control" name='StdWHrs' value={formData.StdWHrs}/></div>
          <div className="col-md-2"><label>Std. WH Rate</label><input type="number" className="form-control" name='StdWHRate' value={formData.StdWHRate}/></div>
          <div className="col-md-2"><label>OT Rate</label><input type="number" className="form-control" name='OTRate' value={formData.OTRate}/></div>
          <div className="col-md-2"><label>Basic+DA(%)</label><input type="number" className="form-control" name='BasicDA_Percent' value={formData.BasicDA_Percent}/></div>
          <div className="col-md-2"><label>DA(Amt)</label><input type="number" className="form-control" name='DA_Amount' value={formData.DA_Amount}/></div>
          <div className="col-md-2"><label>HRA(%)</label><input type="number" className="form-control" name='HRA_Percent' value={formData.HRA_Percent}/></div>
          <div className="col-md-2"><label>Call(%)</label><input type="number" className="form-control" name='Call_Percent' value={formData.Call_Percent}/></div>
          <div className="col-md-2"><label>Convey(%)</label><input type="number" className="form-control" name='Convey_Percent' value={formData.Convey_Percent}/></div>
          <div className="col-md-2"><label>Other(%)</label><input type="number" className="form-control" name='Other_Percent' value={formData.Other_Percent}/></div>
        </div>
      ) : (
        <div className="row bg-light p-3 rounded">
          <div className="col-md-2"><label>Gross</label><input type="number" className="form-control" name='GrossAmount' value={formData.GrossAmount}/></div>
          <div className="col-md-2"><label>Basic (Basic+DA=50%)</label><input type="number" className="form-control" name='BasicAmount' value={formData.BasicAmount}/></div>
          <div className="col-md-2"><label>DA</label><input type="number" className="form-control" name='DA_Component' value={formData.DA_Component}/></div>
          <div className="col-md-2"><label>HRA (20%)</label><input type="number" className="form-control" name='HRA_Amount' value={formData.HRA_Amount}/></div>
          <div className="col-md-2"><label>Call (10%)</label><input type="number" className="form-control" name='Call_Amount' value={formData.Call_Amount}/></div>
          <div className="col-md-2"><label>Convey (10%)</label><input type="number" className="form-control" name='Convey_Amount' value={formData.Convey_Amount}/></div>
          <div className="col-md-2"><label>Other (10%)</label><input type="number" className="form-control" name='Other_Amount' value={formData.Other_Amount}/></div>
        </div>
      )}
    </div>

    );  

  const activeEmpId = (empolyeeid && empolyeeid !== ":empolyeeid" && empolyeeid !== "undefined") ? empolyeeid : ":empolyeeid";

  return (
    <div className="container-fluid page-body-wrapper">
      <InnerHeader />
      <div className="main-panel">
        <div className="content-wrapper">
          {/* Top Navigation Tabs */}
          <div className="d-flex flex-wrap">
            <div className='px-2 mx-2'><Link to={`/employeepersonaldetails/${activeEmpId}`}><h4>Personal Information</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/emailcredential/${activeEmpId}`}><h4>Email Credential</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/academicqualificationsemp/${activeEmpId}`}><h4>Academic Qualification</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/workexperience/${activeEmpId}`}><h4>Work Experience</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/leavestructure/${activeEmpId}`}><h4>Leave Structure</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/salarystructure/${activeEmpId}`}><h4>Salary Structure</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/weeklyoff/${activeEmpId}`}><h4>Weekly Off</h4></Link></div>
            <div className='px-2 mx-2'><Link to={`/intimesetting/${activeEmpId}`}><h4>Intime Setting</h4></Link></div>
          </div>

          {/* Salary Display */}
          <div className="col-lg-12 grid-margin stretch-card mt-4">
            <div className="card">
              <div className="card-body">
                <h2 className="card-title titleback">Salary Structure</h2>
                <hr />

                {/* Case: No rows */}
                {rows.length === 0 ? (
                  <div className="border p-3 mb-4 rounded bg-light">
                    <div className="row">
                      <div className="col-md-3 d-flex flex-column">
                        <label>Options</label>
                        <div className="d-flex gap-2">
                          <button className="btn btn-success btn-sm" onClick={() => handleToggleForm(-1)}>
                            {visibleFormIndex === -1 ? "Save Form" : "Add Salary"}
                          </button>
                          <button className="btn btn-primary btn-sm">Edit Salary</button>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label>Salary Type</label>
                        <input type="text" className="form-control" value="" readOnly />
                      </div>
                      <div className="col-md-3">
                        <label>From Date</label>
                        <input type="date" className="form-control" value="" readOnly />
                      </div>
                      <div className="col-md-3">
                        <label>To Date</label>
                        <input type="date" className="form-control" value="" readOnly />
                      </div>
                    </div>
                    {visibleFormIndex === -1 && SalaryForm()}
                  </div>
                ) : (
                  rows.map((row, index) => (
                    <div key={index} className="border p-3 mb-4 rounded bg-light">
                      <div className="row">
                        <div className="col-md-3 d-flex flex-column">
                          <label>Options</label>
                          <div className="d-flex gap-2">
                            <button className="btn btn-success btn-sm" onClick={() => handleToggleForm(index)}>
                              {visibleFormIndex === index ? "Close Form" : "Add Salary"}
                            </button>
                            <button className="btn btn-primary btn-sm">Edit Salary</button>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <label>Salary Type</label>
                          <input type="text" className="form-control" name="SalaryHead" value={row.SalaryHead} readOnly />
                        </div>
                        <div className="col-md-3">
                          <label>From Date</label>
                          <input type="date" className="form-control" name="FromDate" value={row.FromDate} readOnly />
                        </div>
                        <div className="col-md-3">
                          <label>To Date</label>
                          <input type="date" className="form-control" name="ToDate" value={row.ToDate} readOnly />
                        </div>
                      </div>
                      {visibleFormIndex === index && SalaryForm()}
                    </div>
                  ))
                  
                )}
                 {/* ✅ Add checkboxes below the above row like this: */}
  <div className="row mt-3">
  <div className="col-md-12 d-flex  align-items-center gap-0">
    {[
      { id: "ot", label: "OT" },
      { id: "pt", label: "PT" },
      { id: "pf", label: "PF" },
      { id: "tds", label: "TDS" },
      { id: "mlwf", label: "MLWF" },
      { id: "esic", label: "ESIC" },
      { id: "leave", label: "Leave" },
    ].map((item) => (
      <div className="form-check d-flex align-items-center " style={{marginLeft: "50px"}} key={item.id}>
        <input
          className="form-check-input"
          type="checkbox"
          id={item.id}
          style={{ marginLeft: "10px" }}
        />
        <label className="form-check-label" htmlFor={item.id} style={{marginRight:"5px",textAlign:'start'}}>
          {item.label}
        </label>
      </div>
    ))}
  </div>
</div>




                <div className="mt-4">
                  <button type="submit" className="btn btn-primary mx-2" onClick={handleSave}>Save</button>
                  <button type="button" className="btn btn-light" onClick={() => window.location.reload()}>Close</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalaryStructure;
